import { Card as AntdCard } from "antd"
import { useMobile } from "hooks/useMobile"
import cx from "clsx"
import styles from "./index.module.less"

const Card = props => {
  const { className, children, variant, shadow, borderRadius = false, padding, style, ...rest } = props

  const { isMobile } = useMobile()

  return (
    <AntdCard
      className={cx(
        className,
        styles.card,
        variant === "gray" && styles.grayed,
        variant === "fill" && styles.filled,
        shadow && styles.shadow
      )}
      style={{
        "--ant-border-radius-lg": isMobile ? "6px" : borderRadius,
        "--ant-padding-lg": padding,
        ...style,
      }}
      {...rest}
    >
      {children}
    </AntdCard>
  )
}

export default Card
